import { FRONTLINE_INCIDENT_REVIEW_ALLOWED_ROLES } from '@/lib/capabilities';
/** Same submission/decision cohort as incident regulator-actions; finance remains plan-only. */
export const NDIS_READ_ROLES = FRONTLINE_INCIDENT_REVIEW_ALLOWED_ROLES;
export const NDIS_DECIDE_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'FACILITY_MANAGER',
  'QUALITY_OFFICER',
  'COMPLIANCE_OFFICER',
  'CLINICAL_LEAD',
  'REGISTERED_NURSE',
  'COORDINATOR',
] as const;
export const NDIS_PLAN_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'FACILITY_MANAGER',
  'FINANCE_OFFICER',
  'REGION_FINANCE_OFFICER',
  'COORDINATOR',
  'CASE_MANAGER',
  'REGION_COMPLIANCE_OFFICER',
] as const;
export const NDIS_OVERLAY_ROLES = [
  ...new Set([...NDIS_READ_ROLES, ...NDIS_DECIDE_ROLES, ...NDIS_PLAN_ROLES]),
];
